import { createContext } from 'react';

export const LanguageContext = createContext({
  language: 'pt',
  setLanguage: () => {},
  translations: {},
});